import { DomainEvent } from "@App/domain/events";

export type EventHandler<E extends DomainEvent = DomainEvent> = (evt: E) => void;

export class EventBus {
  private handlers: { [K in DomainEvent["type"]]?: EventHandler[] } = {};
  publish<E extends DomainEvent>(evt: E) {
    this.handlers[evt.type]?.forEach((h) => h(evt));
  }
  subscribe<T extends DomainEvent["type"]>(
    type: T,
    handler: EventHandler<Extract<DomainEvent, { type: T }>>,
  ) {
    (this.handlers[type] ??= []).push(handler as EventHandler);
    return () => {
      this.handlers[type] = this.handlers[type]?.filter((h) => h !== handler);
    };
  }
}
export const bus = new EventBus();
